import {Component, OnInit, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import { ApiResponse } from 'common-shared';
import { RoleModel } from '../role.model';
import { BehaviorSubject} from 'rxjs';
import { switchMap} from 'rxjs/operators';
import {NgForm} from "@angular/forms";
import {RoleService} from "../role.service";

@Component({
  selector: 'mes-role-edit',
  templateUrl: './role-edit.component.html',
  styles: []
})
export class RoleEditComponent implements OnInit {
  @Input() role: RoleModel;
  @Output() roleChanged = new EventEmitter<boolean>();
  @Input() response: ApiResponse<any>;
  refreshToken$ = new BehaviorSubject(undefined);
  privileges$ = this.refreshToken$.pipe(
    switchMap(() => this.roleService.getAllPrivileges()),
    );
  @ViewChild(NgForm, {static: true}) form: NgForm;

  constructor(private roleService: RoleService) {}

  ngOnInit() {
    this.form.statusChanges.subscribe(value => {
      this.roleChanged.emit(this.form.pristine);
    });
  }
}
